import React from 'react';
import {Route, Switch} from 'react-router-dom';

import NetworksList from 'routes/app/components/Configuration/NetworkList';
import NetworkForm from 'routes/app/components/Configuration/NetworkForm';

class Twitter extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}/edit/:id`}
               render={( props ) => <NetworkForm type="twitter" {...props}/>}/>
        <Route path={`${this.props.match.path}/new`} render={( props ) => <NetworkForm type="twitter" {...props}/>}/>
        <Route path={`${this.props.match.path}`} render={() => <NetworksList type="twitter"/>}/>
      </Switch>
    )
  }
}

module.exports = Twitter;



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/twitter/index.js